exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:rgba(0,79,111,.7)!important}.half-circle-spinner .circle-2{border-bottom-color:#a9ac12!important}.v-application--wrap{font-family:Open Sans!important}.v-application--wrap h1.display-1,.v-application--wrap h2.display-1,.v-application--wrap h3.display-1{color:#51307d;margin-bottom:16px}", ""]);
// Exports
exports.locals = {
	"primary": "#004f6f",
	"primaryLight": "rgba(0,79,111,.7)",
	"secondary": "#ae0077",
	"secondaryBright": "rgba(220,0,119,.7)",
	"accent": "#a9ac12",
	"neutralLight": "#d9d9d9",
	"neutralBright": "#fff",
	"brandGrey": "#cfd5dd",
	"backgroundNeutral": "#f2f2f2",
	"success": "#095",
	"textColor": "#333",
	"textBright": "#fff",
	"textLinks": "#333",
	"headerColor": "#004f6f"
};